import React from "react";
import { Modal } from "react-bootstrap";
import "./Success_modal.css";
import Success_lottie from "../../../animation/success_lottie/Success_lottie";


function Success_modal({ message_text, animationData, ...props }) {
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="Success_modal custom_modal"
    >
      <Modal.Body>
        <div className="lottie_holder">
          <Success_lottie animationData={animationData} />
        </div>

        <h6>{message_text}</h6>
      </Modal.Body>
    </Modal>
  );
}

export default Success_modal;
